import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    requestAnimationFrame(() => this.scrollToFirstError());
  }

  scrollToFirstError() {
    const errors = this.element.querySelectorAll(".text-error");
    const first = [...errors].find((el) => el.getClientRects().length > 0);

    if (!first) return;

    const reduceMotion = window.matchMedia(
      "(prefers-reduced-motion: reduce)",
    ).matches;

    first.scrollIntoView({
      behavior: reduceMotion ? "auto" : "smooth",
      block: "center",
    });
  }
}
